import toast from "react-hot-toast";

const useRequestLocationAccess = (refreshLocation) => {
  const requestLocationAccess = async () => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      toast.error("Geolocation is not supported by this browser.");
      return;
    }

    if (navigator.permissions) {
      try {
        const permissionStatus = await navigator.permissions.query({
          name: "geolocation",
        });

        if (permissionStatus.state === "denied") {
          toast(
            (t) => (
              <div className="location-toast">
                <div className="location-toast-icon">
                  <i className="fa fa-map-marker" aria-hidden="true" />
                </div>

                <div className="location-toast-content">
                  <h2 className="location-toast-title">Location Access Blocked</h2>

                  <p className="location-toast-description">
                    To enable live location, click the lock or site-info icon in
                    your browser address bar, allow Location, then retry.
                  </p>

                  <div className="location-toast-actions">
                    <button
                      className="location-toast-btn primary"
                      onClick={() => toast.dismiss(t.id)}
                    >
                      Got it
                    </button>
                  </div>
                </div>
              </div>
            ),
            {
              id: "location-permission-denied",
              duration: Infinity,
              style: {
                background: "transparent",
                border: "none",
                boxShadow: "none",
                padding: 0,
              },
            }
          );

          return;
        }
      } catch (error) {
        console.warn("Could not read geolocation permission state", error);
      }
    }

    refreshLocation();
  };

  return requestLocationAccess;
};

export default useRequestLocationAccess;
